import { motion } from "framer-motion";
import { CHAPTERS } from "../../data";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Manifesto = () => {
  return (
    <section
      id="ethos"
      data-testid="manifesto-section"
      className="max-w-[1600px] mx-auto px-6 md:px-12 py-28 md:py-40"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="mb-20 max-w-3xl"
      >
        <p className="font-sans-lux text-xs uppercase tracking-[0.3em] text-[#D49A44] mb-6">
          Our Ethos
        </p>
        <h2 className="font-serif-lux font-light text-4xl sm:text-5xl lg:text-6xl leading-tight tracking-tight text-[#F4EFE6]">
          Four principles, upheld across four generations.
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16 lg:gap-y-24">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.no}
            custom={i}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            className="relative border-t border-[#2C2621] pt-8"
          >
            <span className="font-serif-lux text-7xl md:text-8xl font-light text-[#D49A44]/20 block mb-4 leading-none">
              {c.no}
            </span>
            <h3 className="font-serif-lux text-2xl sm:text-3xl text-[#F4EFE6] mb-4">
              {c.title}
            </h3>
            <p className="font-sans-lux text-base text-[#B0A89D] leading-relaxed max-w-md">
              {c.body}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
